define('modules/editor/views/correodirect_forms_empty_view',['require','exports','module','base/itemview','ldsh!../templates/correodirect_forms_empty_view'],function(require, exports, module){
  "use strict";

  var ItemView = require("base/itemview");

  module.exports = ItemView.extend({
    template: require("ldsh!../templates/correodirect_forms_empty_view")
  });
});

